function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "result",
  transform: "translate(0.125 0.125)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_40",
  "data-name": "Path 40",
  d: "M29.263,6H6.57A1.57,1.57,0,0,0,5,7.57V28.9a1.57,1.57,0,0,0,1.57,1.57H29.263a1.57,1.57,0,0,0,1.57-1.57V7.57A1.57,1.57,0,0,0,29.263,6Zm.211,22.9a.211.211,0,0,1-.211.211H6.57A.211.211,0,0,1,6.36,28.9V7.57A.211.211,0,0,1,6.57,7.36H29.263a.211.211,0,0,1,.211.211Z",
  transform: "translate(-5 -6)",
  fill: "#024649",
  stroke: "#024649",
  strokeWidth: 0.25
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_41",
  "data-name": "Path 41",
  d: "M21.119,23.237A6.119,6.119,0,1,0,15,17.119,6.119,6.119,0,0,0,21.119,23.237Zm0-10.877a4.759,4.759,0,1,1-4.759,4.759,4.759,4.759,0,0,1,4.759-4.759Z",
  transform: "translate(-8.202 -7.601)",
  fill: "#024649",
  stroke: "#024649",
  strokeWidth: 0.25
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_42",
  "data-name": "Path 42",
  d: "M22.256,20.9a.68.68,0,0,0,.959,0l2.719-2.719a.68.68,0,0,0-.959-.959L22.738,19.46,21.182,17.9a.68.68,0,0,0-.959.959Z",
  transform: "translate(-9.822 -9.541)",
  fill: "#024649",
  stroke: "#024649",
  strokeWidth: 0.25
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_43",
  "data-name": "Path 43",
  d: "M28,31H11.68a.68.68,0,0,0,0,1.36H28A.68.68,0,1,0,28,31Z",
  transform: "translate(-6.921 -14.004)",
  fill: "#024649",
  stroke: "#024649",
  strokeWidth: 0.25
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_44",
  "data-name": "Path 44",
  d: "M26.2,35H16.68a.68.68,0,0,0,0,1.36H26.2a.68.68,0,1,0,0-1.36Z",
  transform: "translate(-8.522 -15.285)",
  fill: "#024649",
  stroke: "#024649",
  strokeWidth: 0.25
}));

function SvgResult(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.084,
    height: 24.724,
    viewBox: "0 0 26.084 24.724",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResult);
export default __webpack_public_path__ + "static/media/result.fe24747c.svg";
export { ForwardRef as ReactComponent };